import request from '../../axios';
import {secondaryGetFormData} from '../../../utilities/helper/formDataConvertor';

const PutStoreRedesignView = async (payload: IStoreLabRedesignView) => {
  await request.put(
    'api/v2/store/store-redesign-view',
    secondaryGetFormData(payload as unknown as {[name: string]: string | Blob}),
  );
};

export default PutStoreRedesignView;
